import { render, staticRenderFns } from "./ServiceProductsManager.vue?vue&type=template&id=41607e24&"
import script from "./ServiceProductsManager.vue?vue&type=script&lang=js&"
export * from "./ServiceProductsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports